import * as React from "react";
import "./footerViewStyles.css";
import { useTranslation } from "react-i18next";
import { useRef, useLayoutEffect } from "react";
export var FooterView = function (_a) {
    var _b = _a.simple, simple = _b === void 0 ? false : _b;
    var t = useTranslation().t;
    var ref = useRef(null);
    useLayoutEffect(function () {
        if (simple)
            return;
        if (!ref.current)
            return;
        var defaultMargin = 32;
        ref.current.style.marginTop = defaultMargin + "px";
        void ref.current.offsetHeight;
        var footerBottom = ref.current.offsetTop + ref.current.offsetHeight;
        var container = ref.current.offsetParent;
        var containerTop = container ? container.offsetTop : 0;
        // Layout lives inside the fixed 1080px design stage (App.tsx scales it to
        // the viewport). Measure against the design height, not window.innerHeight,
        // which is device px and would be wrong once the stage is scaled.
        var DESIGN_H = 1080;
        var availableHeight = DESIGN_H - 24 - containerTop;
        if (footerBottom < availableHeight) {
            var extra = availableHeight - footerBottom;
            ref.current.style.marginTop = defaultMargin + extra + "px";
        }
    });
    return (React.createElement("div", { className: "footer-container", ref: ref },
        React.createElement("p", { className: "left-container" },
            new Date().getFullYear(),
            " cavea.plus"),
        React.createElement("p", { className: "right-container" }, t("footer.rights"))));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/views/footer/FooterView.tsx
// module id = 28
// module chunks = 1